import './App.css'; // Optional: keep for specific small tweaks, though index.css handles most
import { Route, Routes } from 'react-router-dom';
import { Navbar } from './components/public/Navbar';
import { Footer } from './components/public/Footer';
import { FloatingButton } from './components/shared/FloatingButton';
import { ContactoScreen } from './screens/ContactoScreen';
import { NosotrosScreen } from './screens/NosotrosScreen';
import { HomeScreen } from './screens/HomeScreen';
import { ServiciosScreen } from './screens/ServiciosScreen';
import { HelmetProvider } from 'react-helmet-async';
// import { Whatsapp } from './components/public/Whatsapp'; // Using FloatingButton instead
// import { ScrollToTopButton } from './components/public/ScrollToTopButton'; // Removed unless requested

function App() {
  return (
    <HelmetProvider>
      <div className="app-container">
        <Navbar />
        <Routes>
          <Route exact path={"/"} element={<HomeScreen />} />
          <Route exact path={"/servicios"} element={<ServiciosScreen />} />
          <Route exact path={"/nosotros"} element={<NosotrosScreen />} />
          <Route exact path={"/contacto"} element={<ContactoScreen />} />
          {/* Servicios ahora está integrado en Home */}
          <Route exact path="*" element={<HomeScreen />} />
        </Routes>
        <FloatingButton />
        <Footer />
      </div >
    </HelmetProvider>
  );
}

export default App;
